import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getPostfixByActualsValueType } from './getPostfixByActualsValueType'

export const getFieldByActualsValueType = <T>(
  field: string,
  valueType: ActualsValueTypes
): keyof T => {
  const postfix = getPostfixByActualsValueType(valueType)

  return `${field}${postfix}` as keyof T
}
